import { render, staticRenderFns } from "./ClosureTable.vue?vue&type=template&id=d2bea6a8&scoped=true"
import script from "./ClosureTable.vue?vue&type=script&lang=js"
export * from "./ClosureTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bea6a8",
  null
  
)

export default component.exports